<template>
    <v-container class="pt-1 px-2" >
        <v-form v-model="valid"
                ref="form"
                lazy-validation
                @submit.prevent="">
            <v-row>
                <v-col cols="12" class="pb-2" v-if="validateEmailOrPhone.value === 'phone'">
                    <country-picker solo v-model="country"/>
                </v-col>

                <v-col class="pb-2" cols="12">
                    <v-text-field :placeholder="$t('login.emailOrPhone')"
                                  hide-details
                                  v-model="emailOrPhone"
                                  solo
                                  @keyup.enter="submit()">
                        <v-row class="fill-height"  align="center" slot="prepend-inner">
                            <v-icon class="px-4"
                                    color="kbDarkBlue">
                                {{ validateEmailOrPhone.icon }}
                            </v-icon>
                            <template v-if="validateEmailOrPhone.value === 'phone'">
                                <div class="pr-3 grey--text">+{{country.number || '1'}}</div>
                            </template>
                        </v-row>
                    </v-text-field>
                </v-col>

                <v-col cols="12" class="pb-1">
                    <v-text-field :placeholder="$t('login.password')"
                                  type="password"
                                  v-model="password"
                                  hide-details
                                  solo
                                  @keyup.enter="submit()">
                        <template slot="prepend-inner">
                            <!--:class="!valid ? 'error&#45;&#45;text' : ''"-->
                            <v-icon color="kbDarkBlue">
                                feather-lock
                            </v-icon>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" class="d-flex justify-space-between align-center pb-0 pt-6">
                    <div class="d-flex align-center" style="position: relative">
                        <div class="kb-login-checkbox mr-2"
                             @click="rememberMe = true"
                             v-show="!rememberMe"/>
                        <v-icon @click="rememberMe = false"
                                class="mr-2"
                                color="kbDarkBlue"
                                size="22px"
                                v-show="rememberMe">
                          mdi-checkbox-marked
                        </v-icon>
                        <span class="kbDarkBlue--text font-weight-regular"
                              style="font-size: 14px">
                            {{ $t('login.rememberMe') }}
                        </span>
                    </div>
                    <span @click="$emit('changeSection', 'keybeResetPassword')"
                          class="text-right kbDarkBlue--text font-weight-regular"
                          style="cursor: pointer; font-size: 14px">
                        {{ $t('login.forgotYourPassword') }}
                    </span>
                </v-col>

                <v-col class="text-center pt-7" cols="12">
                    <v-btn color="#11CDEF"
                           @click="submit()"
                           dark
                           :loading="loading"
                           style="font-size: 16px; width: 150px">
                        {{ $t('login.signIn') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import CountryPicker from '@/components/ui/CountryPicker.vue'
import notifications from '@/libs/notifications'
import validations from '@/libs/validations'
export default {
  components: { CountryPicker },
  computed: {
    validateEmailOrPhone () {
      const patternOnlyNumbers = /^[0-9]+$/
      if (!this.emailOrPhone) return { icon: 'feather-user', value: 'none' }
      if (patternOnlyNumbers.test(this.emailOrPhone)) return { icon: 'fas fa-mobile-alt', value: 'phone' }
      if (!patternOnlyNumbers.test(this.emailOrPhone)) return { icon: 'far fa-envelope', value: 'email' }
      else return ''
    }
  },
  data () {
    return {
      valid: false,
      loading: false,
      country: {},
      emailOrPhone: '',
      password: '',
      rememberMe: false
    }
  },
  methods: {
    submit () {
      const loginType = this.validateEmailOrPhone.value
      if (!loginType || loginType === 'none' || !this.emailOrPhone.trim()) {
        notifications.error(this.$t('rules.emailOrPhoneAreRequired'))
        return
      }
      const registerWithPhone = this.validateEmailOrPhone.value === 'phone'
      if (!validations.login({
        emailOrPhone: this.emailOrPhone,
        password: this.password,
        registerWithPhone
      })) return

      const emailOrPhoneAPI = loginType === 'phone' ? 'loginPhone' : 'loginEmail'
      this.loading = true
      this.$store.dispatch(emailOrPhoneAPI, { userData: this.emailOrPhone, password: this.password })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          notifications.error(error.message)
        })
    }
  }
}
</script>

<style scoped>
    .kb-login-checkbox {
        width: 22px;
        height: 22px;
        cursor: pointer;
        background-color: white;
        border-radius: 2px;
        box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2);
    }
    ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
        box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
        text-decoration: none!important;
    }
    ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot input {
        border-bottom: none!important;
    }
</style>
